import { useStore } from 'effector-react'

import {
  $clients,
  $totalCountOfClients,
  clientsListMounted,
  getClients,
} from './model'
import { ClientRequest } from './types'

export const useClientsList = () => {
  const onChangeClientsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    filters,
  }: ClientRequest) => {
    clientsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      filters,
    })
  }

  const loading = useStore(getClients.pending)

  const clients = useStore($clients)
  const totalCountOfClients = useStore($totalCountOfClients)

  return { clients, totalCountOfClients, loading, onChangeClientsList }
}
